module.exports = __webpack_public_path__ + "static/img/1072_big.bb59129.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1072_big.png
// module id = +qSw
// module chunks = 1